import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTDeleteAPIInviteResult,
	RESTGetAPIInviteQuery,
	RESTGetAPIInviteResult
} from "discord-api-types/v10";





class InviteMethods {








	public constructor(public requestHandler: RH) {}













	public async getInvite(inviteId: string, options?: RESTGetAPIInviteQuery): Promise<RESTGetAPIInviteResult> {
		return this.requestHandler.request(Endpoints.INVITES(inviteId), options, "get", "json");
	}
















	public async deleteInvite(inviteId: string): Promise<RESTDeleteAPIInviteResult> {
		return this.requestHandler.request(Endpoints.INVITES(inviteId), {}, "delete", "json");
	}
}

export = InviteMethods;
